module.exports = __webpack_public_path__ + "img/LO.3d45fde5.jpg";